import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import GalleryContent from "../ones/GalleryContent";

export default function View(props) {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <>
      <GalleryContent />
      <Footer />
    </>
  );
}
